import { useStaticQuery,graphql } from "gatsby";
import React from "react";
import { saveAs } from 'file-saver'

import {connect} from 'react-redux'

//Helpers
import Loading from '../../components/Loading'
import { getFile } from "../../helpers/helper.rendering";


const Files = ({files,loading}) => {
    const { realEstate: {design: {icons},template_version,proFeatures}} = useStaticQuery(graphql`
            query {
                realEstate {
                    template_version
                    proFeatures{
                        downFiles
                    }
                    design {
                        icons
                    }
                }
    }`)
    const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''
    const MediaPro = template_version === 'PRO' ? true : false;
    const {downFiles} = proFeatures

    if(files === 'undefined'){return null}
    if(files?.length === 0 || downFiles === false){return null}
    
    const downloadImage = (url,name,ext) => {
        saveAs(url, name + ext) // Put your image url here.
    }

    return !loading ? (
        <div class="files-zone mt-lg-0 mt-4">
                <div class="container-fluid">
                    <div class="row intro">
                        <div class="col-lg-12">
                            <h4 class="mb-lg-4 mb-3 text-uppercase">Descargas</h4>
                        </div>
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-12">
                                    {files?.map(file => (
                                        
                                         <a target="_blank" onClick={() => downloadImage(file.file,getFile(file).name,getFile(file).ext)} className={"btn-file me-3 d-lg-inline-flex d-flex mb-3 align-items-center justify-content-center justify-content-lg-start"} href={file.file} download>
                                            <i className={`order-lg-1 order-2 icon-download${iconsStyle}`}></i>
                                            <div className="ms-2 d-flex order-lg-2 order-1 name-file">{getFile(file).name}.{getFile(file).ext}</div>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    ):
    <>
      <Loading absolute={true}/>
    </>
}

export default connect(state => ({
    loading: state.developments.loading,
}),null)(Files);